// extracted by mini-css-extract-plugin
export default {"root":"ExpandableBio_root__X9VT5","showMore":"ExpandableBio_showMore__OODEN"};